<template>
  <div>
    <!-- Header -->
    <LoadingPage v-if="isLoadPage" />

    <!-- Page content -->
    <b-card no-body class="bg-secondary border-0 pt-6">
      <b-card-header class="pb-3">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <router-link to="/auth/home">
              <i class="ni ni-bold-left text-primary"></i>
            </router-link>
          </div>
          <div class="text-primary h3 mb-0 flex-grow-1">งานที่กำลังทำ</div>
        </div>
      </b-card-header>
    </b-card>
    <b-container class="py-3 py-lg-4 pt-lg-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <CardJobDetails :job="job" />

          <b-tabs pills card class="tab-job-details my-3">
            <b-tab
              title="สิ่งที่ต้องทำ"
              title-item-class="flex-grow-1 mb-0 text-center"
              active>
              <b-card class="card-work-job border-0">
                <b-card-header class="bg-transparent p-2 border-0">
                  <div
                    class="d-flex justify-content-between align-items-center">
                    <h3 class="mb-0">รายละเอียดรถส่งสินค้า</h3>
                  </div>
                </b-card-header>
                <b-card-body>
                  <b-row>
                    <b-col lg="12">
                      <div class="h4">
                        <span class="text-muted">รูปแบบการเติมน้ำมัน : </span>
                        <span>{{
                          job.vehicle ? job.vehicle.engine_type : ""
                        }}</span>
                      </div>
                    </b-col>
                    <b-col lg="12">
                      <b-form-group label="เวลาขึ้นงาน" label-for="input-time">
                        <b-form-input
                          id="input-time"
                          placeholder="เวลาขึ้นงาน"
                          v-model="job.driver_assigned_date"
                          disabled>
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="12">
                      <b-form-group
                        label="อุณหภูมิรถ"
                        label-for="input-heat"
                        v-if="job.vehicle">
                        <b-form-input
                          id="input-heat"
                          placeholder="อุณหภูมิรถ"
                          v-model="job.vehicle.vehicleCategory.degrees"
                          disabled>
                        </b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="px-0">
                      <!-- <draggable
                        v-bind="dragOptions()"
                        v-model="job.jobRoutes"
                        :disabled="job.jobRoutes.some((route) => route.visible)"
                        @end="onDragEnd"> -->
                      <b-list-group
                        v-for="(route, index) in job.jobRoutes"
                        :key="index">
                        <b-list-group-item
                          :key="index"
                          class="d-flex justify-content-between align-items-center py-3 border-right-0 border-left-0"
                          role="tab"
                          href="javascript:;"
                          v-b-toggle="`location_${index}`">
                          <span class="h3 mb-0">
                            <b-icon
                              :icon="
                                index === 0
                                  ? 'pin-map-fill'
                                  : index === job.jobRoutes.length - 1
                                  ? 'symmetry-horizontal'
                                  : 'record-circle-fill'
                              "
                              class="text-primary pr-1"></b-icon>
                            {{
                              index === 0
                                ? `ต้นทาง - (${
                                    route.name ? route.name : "untitled"
                                  })`
                                : index === job.jobRoutes.length - 1
                                ? `ปลายทาง - (${
                                    route.name ? route.name : "untitled"
                                  })`
                                : `ระหว่างทาง - (${
                                    route.name ? route.name : "untitled"
                                  })`
                            }}
                            <span
                              class="h5 text-success"
                              v-if="checkIsSuccess(route.status)">
                              ( ส่งงานแล้ว )
                            </span>
                          </span>
                          <i
                            class="ni"
                            :class="
                              route.visible ? 'ni-bold-up' : 'ni-bold-down'
                            "></i>
                        </b-list-group-item>
                        <b-collapse
                          :id="`location_${index}`"
                          v-model="route.visible">
                          <b-card class="bg-secondary">
                            <b-card-body class="p-0">
                              <b-row>
                                <!-- ปุ่มลบเส้นทาง
                                  <b-col cols="12" class="text-right">
                                    <b-button
                                      variant="outline-danger"
                                      size="sm"
                                      @click="deleteRoute(route)">
                                      <b-icon icon="trash"></b-icon> </b-button
                                  ></b-col> -->
                                <b-col cols="12">
                                  <b-form-group
                                    label="สถานที่"
                                    label-for="input-place">
                                    <b-form-input
                                      id="input-place"
                                      placeholder="ระบุสถานที่"
                                      v-model="route.name"
                                      disabled>
                                    </b-form-input>
                                  </b-form-group>
                                  <b-form-group
                                    label="ไมล์เริ่มงาน"
                                    label-for="input-mile">
                                    <b-form-input
                                      id="input-mile"
                                      type="number"
                                      min="0"
                                      placeholder="เลขไมล์เริ่มงาน"
                                      v-model="route.startMile"
                                      :disabled="checkIsSuccess(route.status)">
                                    </b-form-input>
                                  </b-form-group>
                                </b-col>
                                <b-col cols="12">
                                  <label>อัพโหลดรูป</label>
                                  <b-list-group>
                                    <b-list-group-item
                                      href="#"
                                      @click="
                                        handleOpenModalImage(TYPE_MILE, index)
                                      ">
                                      <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div>
                                          <b-icon
                                            :icon="
                                              route.image_mile_count > 0
                                                ? 'check-circle'
                                                : 'circle'
                                            "
                                            class="text-primary"></b-icon>
                                          <span class="px-2"
                                            >รูปไมล์เริ่มงาน</span
                                          >
                                          <small class="text-muted"
                                            >(
                                            {{
                                              route.image_mile_count
                                                ? route.image_mile_count
                                                : 0
                                            }}
                                            รูป )</small
                                          >
                                        </div>
                                        <div>
                                          <i class="ni ni-bold-right"></i>
                                        </div>
                                      </div>
                                    </b-list-group-item>
                                    <b-list-group-item
                                      href="#"
                                      @click="
                                        handleOpenModalImage(
                                          TYPE_INVOICE,
                                          index
                                        )
                                      ">
                                      <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div>
                                          <b-icon
                                            :icon="
                                              route.image_invoice_count > 0
                                                ? 'check-circle'
                                                : 'circle'
                                            "
                                            class="text-primary"></b-icon>
                                          <span class="px-2">Invoice</span>
                                          <small class="text-muted"
                                            >(
                                            {{
                                              route.image_invoice_count
                                                ? route.image_invoice_count
                                                : 0
                                            }}
                                            รูป )</small
                                          >
                                        </div>
                                        <div>
                                          <i class="ni ni-bold-right"></i>
                                        </div>
                                      </div>
                                    </b-list-group-item>
                                    <b-list-group-item
                                      href="#"
                                      @click="
                                        handleOpenModalImage(
                                          TYPE_PRODUCT,
                                          index
                                        )
                                      ">
                                      <div
                                        class="d-flex justify-content-between align-items-center">
                                        <div>
                                          <b-icon
                                            :icon="
                                              route.image_product_count > 0
                                                ? 'check-circle'
                                                : 'circle'
                                            "
                                            class="text-primary"></b-icon>
                                          <span class="px-2">รูปสินค้า</span>
                                          <small class="text-muted"
                                            >(
                                            {{
                                              route.image_product_count
                                                ? route.image_product_count
                                                : 0
                                            }}
                                            รูป )</small
                                          >
                                        </div>
                                        <div>
                                          <i class="ni ni-bold-right"></i>
                                        </div>
                                      </div>
                                    </b-list-group-item>
                                  </b-list-group>
                                </b-col>
                              </b-row>
                              <b-row class="my-3">
                                <b-col cols="12">
                                  <b-button-group
                                    class="w-100 px-4"
                                    v-if="!checkIsSuccess(route.status)">
                                    <b-button
                                      variant="outline-primary"
                                      @click="saveFormJobRoutesById(route)">
                                      <b-icon icon="save"></b-icon>
                                      บันทึกฟอร์ม
                                    </b-button>
                                    <b-button
                                      variant="primary"
                                      class="px-5"
                                      @click="submitRoute(route.id)">
                                      ส่งงาน
                                    </b-button>
                                  </b-button-group>
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-card>
                        </b-collapse>
                      </b-list-group>
                      <!-- </draggable> -->
                    </b-col>
                  </b-row>
                </b-card-body>
                <!-- <b-card-body>
                  <b-row>
                    <b-col cols="12">
                      <b-button block @click="addRoute()" class="mb-2">
                        <b-icon icon="plus"></b-icon>
                        เพิ่มเส้นทาง
                      </b-button>
                    </b-col>
                    <b-col cols="12">
                      <b-button block @click="saveFormJobRoutes()">
                        <b-icon icon="save"></b-icon>
                        บันทึกเส้นทาง
                      </b-button>
                    </b-col>
                  </b-row>
                </b-card-body> -->
                <b-card-body>
                  <b-row>
                    <b-col cols="12" class="px-0">
                      <b-list-group
                        v-if="job.jobRateType && job.jobRateType.id === 1">
                        <b-list-group-item
                          class="d-flex justify-content-between align-items-center py-3 border-right-0 border-left-0"
                          role="tab"
                          href="javascript:;"
                          v-b-toggle="`location_warehouse`">
                          <span class="h3 mb-0">
                            <b-icon
                              icon="shop-window"
                              class="text-primary pr-1">
                            </b-icon>
                            กลับคลังสินค้า
                            <span
                              class="h5 text-success"
                              v-if="job.distance_to_warehouse > 0">
                              ( ส่งงานแล้ว )
                            </span>
                          </span>
                          <i
                            class="ni"
                            :class="
                              warehouse.visible ? 'ni-bold-up' : 'ni-bold-down'
                            "></i>
                        </b-list-group-item>
                        <b-collapse
                          :id="`location_warehouse`"
                          v-model="warehouse.visible">
                          <b-card class="bg-secondary">
                            <b-card-body class="p-1">
                              <b-row>
                                <b-col cols="12">
                                  <b-form-group
                                    label="ระยะทางกลับคลัง (ก.ม.)"
                                    label-for="input-distance">
                                    <b-form-input
                                      v-model="job.distance_to_warehouse"
                                      id="input-distance"
                                      placeholder="ระยะทางกลับคลัง">
                                    </b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                              <b-row class="my-2">
                                <b-col cols="12">
                                  <b-button-group class="w-100 px-4">
                                    <b-button
                                      variant="primary"
                                      class="px-5"
                                      @click="submitRouteWarehouse()">
                                      ส่งงาน
                                    </b-button>
                                  </b-button-group>
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-card>
                        </b-collapse>
                      </b-list-group>
                      <b-list-group
                        v-for="(additional, index) in job.jobAdditional"
                        :key="additional.id">
                        <b-list-group-item
                          class="d-flex justify-content-between align-items-center py-3 border-right-0 border-left-0"
                          role="tab"
                          href="javascript:;"
                          v-b-toggle="`location_extra_${additional.id}`">
                          <span class="h3 mb-0">
                            <b-icon icon="bookmark" class="text-primary pr-1">
                            </b-icon>
                            งานเพิ่มเติม
                            <span class="h5 text-muted">({{ index + 1 }})</span>
                            <span
                              class="h5 text-success"
                              v-if="checkIsSuccess(additional.status)">
                              ( ส่งงานแล้ว )
                            </span>
                          </span>
                          <i
                            class="ni"
                            :class="
                              additional.visible ? 'ni-bold-up' : 'ni-bold-down'
                            "></i>
                        </b-list-group-item>
                        <b-collapse
                          :id="`location_extra_${additional.id}`"
                          v-model="additional.visible">
                          <b-card class="bg-secondary">
                            <b-card-body class="p-1">
                              <b-row>
                                <b-col cols="12">
                                  <b-form-group
                                    label="รายละเอียดงาน"
                                    label-for="input-job-extra-details">
                                    <b-form-input
                                      id="input-job-extra-details"
                                      placeholder="รายละเอียดงาน"
                                      v-model="additional.name"
                                      disabled>
                                    </b-form-input>
                                  </b-form-group>
                                </b-col>
                              </b-row>
                              <b-row class="my-2">
                                <b-col cols="12">
                                  <b-button
                                    variant="primary"
                                    block
                                    :disabled="
                                      additional.status === STATUS_SUCCESS
                                    "
                                    @click="submitAdditional(additional.id)">
                                    {{
                                      additional.status === STATUS_SUCCESS
                                        ? "ส่งงานแล้ว"
                                        : "ส่งงาน"
                                    }}
                                  </b-button>
                                </b-col>
                              </b-row>
                            </b-card-body>
                          </b-card>
                        </b-collapse>
                      </b-list-group>
                    </b-col>
                  </b-row>
                </b-card-body>
                <b-card-body class="my-3">
                  <b-card class="bg-secondary">
                    <b-card-body>
                      <div class="d-flex justify-content-between">
                        <div class="text-muted">ระยะทางรวมการสิ่งสินค้า</div>
                        <div>
                          <span class="h2">{{ job.distance }}</span>
                          <span class="text-muted"> กม.</span>
                        </div>
                      </div>
                      <hr class="my-3 bg-primary" />
                      <b-row>
                        <b-col cols="12">
                          <b-button
                            variant="primary"
                            block
                            @click="confirmCloseJob">
                            ปิดงาน
                          </b-button>
                        </b-col>
                        <b-col cols="12" class="mt-2">
                          <ButtonJobPartTime />
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-card-body>
              </b-card>
            </b-tab>
            <b-tab
              title="รายการใช้จ่าย"
              title-item-class="flex-grow-1 mb-0 text-center">
              <CardJobExpenses :jobId="jobId" />
            </b-tab>
          </b-tabs>
          <UploadImage
            :upload="upload"
            :route="job.jobRoutes[routeIndex]"
            @images-uploaded="uploadImagesByType"
            @images-to-delete="deleteImagesByType" />

          <ModalConfirm ref="confirmDelete" :confirm="confirm" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import jobServices from "@/api/job.service.js";
import UploadImage from "@/components/Modal/Image/UploadImage.vue";
import draggable from "vuedraggable";
import CardJobDetails from "@/components/Job/CardJobDetails.vue";
import ModalConfirm from "@/components/Modal/Alert/ModalConfirm.vue";
import CardJobExpenses from "@/components/Job/CardJobExpenses.vue";
import ButtonJobPartTime from "@/components/Job/ButtonJobPartTime.vue";
import { formatThaiDate } from "@/util/format.js";
import { STATUS_SUCCESS } from "@/util/constants.js";
import { modalSuccess, modalError } from "@/util/alert.js";

const TYPE_MILE = "mile";
const TYPE_INVOICE = "invoice";
const TYPE_PRODUCT = "product";
export default {
  name: "workAfter",
  components: {
    CardJobDetails,
    UploadImage,
    ModalConfirm,
    CardJobExpenses,
    ButtonJobPartTime,
    draggable,
  },
  data() {
    return {
      isLoadPage: false,
      upload: {
        title: "",
        type: "",
      },
      confirm: {
        show: false,
        icon: '<i class="fas fa-times-circle text-red fa-5x"></i>',
        emphasize: "ต้องการลบรายการ",
        text: "กรุณาตรวจสอบข้อมูล หากลบรายการแล้วจะไม่สามารถกู้คืนได้",
        isLoad: false,
      },
      routeIndex: null,
      uploadJobImages: {},
      isUploadJobImages: false,
      jobId: null,
      job: { jobRoutes: [] },
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
      visibleOrigin: false,
      visibleImage: false,
      TYPE_MILE: TYPE_MILE,
      TYPE_INVOICE: TYPE_INVOICE,
      TYPE_PRODUCT: TYPE_PRODUCT,
      STATUS_SUCCESS: STATUS_SUCCESS,
      warehouse: {
        visible: false,
      },
      extra: {
        visible: false,
      },
    };
  },
  computed: {
    jobRoutes() {
      return this.job.jobRoutes;
    },
  },
  methods: {
    checkParam() {
      if (!this.$route.params.id) {
        this.$router.push("auth/home");
        return;
      }
      this.jobId = Number(this.$route.params.id);
    },
    formatNames(files) {
      return files.length === 1
        ? files[0].name
        : `${files.length} files selected`;
    },
    async uploadJobImage(jobRouteId) {
      this.isUploadJobImages = true;
      if (!this.uploadJobImages[jobRouteId]) {
        this.isUploadJobImages = false;
        modalError(this.$bvModal, "กรุณาเลือกรูปภาพ");
        return;
      }

      const formData = new FormData();
      for (let file of this.uploadJobImages[jobRouteId]) {
        formData.append("file", file);
      }
      formData.append("job_id", this.job.id);
      formData.append("route_id", jobRouteId);
      try {
        this.isLoadPage = true;
        const response = await jobServices.uploadJobDriverImages(formData);
        modalSuccess(this.$bvModal, "อัพโหลดรูปเสร็จสิ้น");
        await this.getJob();
      } catch (error) {
        console.error("Error uploading images", error);
        modalError(this.$bvModal, "เกิดข้อผิดพลาดในการอัพโหลด");
      } finally {
        this.isUploadJobImages = false;
        this.isLoadPage = false;
      }
    },
    async getJob(routeId) {
      try {
        this.isLoadPage = true;
        const res = await jobServices.getDriverJobById({ id: this.jobId });
        const job = res.data.data;
        const jobRoutes = job.jobRoutes.map((item) => {
          return {
            ...item,
            visible: item.id === routeId ? true : false,
            startMile: item.mile ? item.mile : null,
            jobImages: {
              [this.TYPE_MILE]: {
                image: [],
                selected: [],
                number: 0,
              },
              [this.TYPE_INVOICE]: {
                image: [],
                selected: [],
                number: 0,
              },
              [this.TYPE_PRODUCT]: {
                image: [],
                selected: [],
                number: 0,
              },
            },
          };
        });

        const jobAdditional = job.jobAdditional.map((item) => {
          return {
            ...item,
            visible: false,
          };
        });

        // if (job.jobRoutes.length === 2) {
        //   jobRoutes.splice(1, 0, {});
        // }

        job.jobRoutes = jobRoutes.sort((a, b) => a.level - b.level);
        job.jobAdditional = jobAdditional;
        job.started_datetime = formatThaiDate(job.started_datetime);
        job.created_date = formatThaiDate(job.created_date);
        job.driver_assigned_date = formatThaiDate(job.driver_assigned_date);

        this.job = job;
      } catch (error) {
      } finally {
        this.isLoadPage = false;
      }
    },
    addInitialRoute() {
      this.ensureJobRoutes();
      this.job.jobRoutes.push(this.createNewRoute());
    },
    addRouteAbove(index) {
      this.ensureJobRoutes();
      this.job.jobRoutes.splice(index, 0, this.createNewRoute());
    },
    addRouteBelow(index) {
      this.ensureJobRoutes();
      this.job.jobRoutes.splice(index + 1, 0, this.createNewRoute());
    },
    addRoute() {
      if (this.job.jobRoutes.length >= 2) {
        const index = this.job.jobRoutes.length - 1;
        this.job.jobRoutes.splice(index, 0, {
          ...this.createNewRoute(index + 1),
        });
      } else {
        this.job.jobRoutes.push({
          ...this.createNewRoute(this.job.jobRoutes.length + 1),
        });
      }
      this.updateLevels();
    },
    ensureJobRoutes() {
      if (!this.job.jobRoutes) {
        this.$set(this.job, "jobRoutes", []);
      }
    },
    createNewRoute(level) {
      return {
        id: 0,
        name: "",
        url: "/",
        jobid: this.jobId,
        vehicle_id: 0,
        startMile: null,
        visible: false,
        pointer_item: 0,
        level: level,
        jobImages: {
          [this.TYPE_MILE]: {
            image: [],
            selected: [],
            number: 0,
          },
          [this.TYPE_INVOICE]: {
            image: [],
            selected: [],
            number: 0,
          },
          [this.TYPE_PRODUCT]: {
            image: [],
            selected: [],
            number: 0,
          },
        },
      };
    },
    async submitAdditional(jobAdditionalId) {
      try {
        this.isLoadPage = true;
        const { data } = await jobServices.sendJobAdditional(
          this.job.id,
          jobAdditionalId
        );
        if (data.statusCode === 200) {
          modalSuccess(this.$bvModal, "ส่งงานเพิ่มเติมสำเร็จ");
          await this.getJob();
        }
      } catch (err) {
      } finally {
        this.isLoadPage = false;
      }
    },
    async handleOpenModalImage(type, routeIndex) {
      this.$bvModal.show("upload-image");
      this.upload.type = type;
      this.routeIndex = routeIndex;
      const jobRoute = this.job.jobRoutes[routeIndex];
      let currentNumber = this.job.jobRoutes[routeIndex].jobImages[type].number;

      let getImages = [];
      getImages = await this.getJobRouteImages(jobRoute.id, type);

      if (type === this.TYPE_MILE) {
        this.upload.title = "รูปไมล์เริ่มงาน";
      } else if (type === this.TYPE_INVOICE) {
        this.upload.title = "Invoice";
      } else if (type === this.TYPE_PRODUCT) {
        this.upload.title = "รูปสินค้า";
      }

      this.job.jobRoutes[routeIndex].jobImages[type].image =
        getImages.images.map((image, index) => ({
          id: image.id,
          key: getImages.key,
          preview: image.image,
          number: currentNumber++, // เพิ่มค่า index เข้ากับ number ที่มีอยู่
        }));
      this.job.jobRoutes[routeIndex].jobImages[type].number +=
        getImages.images.length;
    },
    async getJobRouteImages(routeId, type) {
      try {
        this.isLoadPage = true;
        const response = await jobServices.getJobRouteImagesByType(
          routeId,
          type
        );
        return response.data.data;
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async getJobRouteMileImages(route_id) {
      try {
        this.isLoadPage = true;
        const response = await jobServices.getJobRouteMileImages(route_id);
        return response.data.data;
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async getJobRouteInvoiceImages(route_id) {
      try {
        this.isLoadPage = true;
        const response = await jobServices.getJobRouteInvoiceImages(route_id);
        return response.data.data;
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        this.isLoadPage = false;
      }
    },

    async getJobRouteProductImages(route_id) {
      try {
        this.isLoadPage = true;
        const response = await jobServices.getJobRouteProductImages(route_id);
        return response.data.data;
      } catch (error) {
        console.error("Error fetching images:", error);
      } finally {
        this.isLoadPage = false;
      }
    },
    async saveFormJobRoutesById(route) {
      try {
        this.isLoadPage = true;
        const payload = {
          id: route.id,
          name: route.name,
          url: route.url,
          level: route.level,
          mile: route.startMile,
        };

        const save = await jobServices.saveFormJobRoutesById(
          this.job.id,
          payload
        );

        await this.getJob(route.id);
        modalSuccess(this.$bvModal, "บันทึกฟอร์มเสร็จสิ้น");
      } catch (err) {
        console.log("error saveFormJobRoutes", err);
        modalError("เกิดข้อผิดพลาด");
      } finally {
        this.isLoadPage = false;
      }
    },
    async saveFormJobRoutes() {
      try {
        this.isLoadPage = true;
        const payload = this.job.jobRoutes.map((item) => {
          return {
            id: item.id,
            name: item.name,
            url: item.url,
            level: item.level,
            mile: item.startMile,
          };
        });

        const save = await jobServices.saveFormJobRoutes(this.job.id, payload);

        await this.getJob();
        modalSuccess(this.$bvModal, "บันทึกเสร็จสิ้น");
      } catch (err) {
        console.log("error saveFormJobRoutes", err);
        modalError(this.$bvModal, "เกิดข้อผิดพลาด");
      } finally {
        this.isLoadPage = false;
      }
    },
    saveRoutePointer() {
      this.job.jobRoutes.map((data, index) => {
        data.pointer_item = index + 1;
      });

      console.log(this.job.jobRoutes, "this.job.jobRoutes");
    },
    dragOptions() {
      return {
        animation: 400,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
    onDragEnd() {
      this.updateLevels();
    },
    updateLevels() {
      this.job.jobRoutes.forEach((route, index) => {
        route.level = index + 1;
      });
      console.log("this.job.jobRoutes", this.job.jobRoutes);
    },
    async uploadImagesByType(event) {
      const formData = new FormData();
      formData.append("job_route_id", event.route_id);

      event.images.forEach((image, index) => {
        if (!image.hasOwnProperty("id")) {
          formData.append("file", image.file);
        }
      });

      try {
        this.isLoadPage = true;
        let response;
        if (event.type === this.TYPE_MILE) {
          response = await jobServices.uploadJobRouteMile(formData);
        } else if (event.type === this.TYPE_INVOICE) {
          response = await jobServices.uploadJobRouteInvoice(formData);
        } else if (event.type === this.TYPE_PRODUCT) {
          response = await jobServices.uploadJobRouteProduct(formData);
        }

        console.log("uploadImagesByType success:", response.data);
        modalSuccess(this.$bvModal, "อัพโหลดรูปเสร็จสิ้น");
        await this.getJob(event.route_id);
      } catch (error) {
        console.error("uploadImagesByType error:", error);
      } finally {
        this.isLoadPage = false;
      }
    },

    async deleteImagesByType(e) {
      try {
        // let response;

        const { data } = await jobServices.deleteJobRouteImagesByType({
          images: e.images,
          file_type: e.type,
        });

        console.log(data, "data");
        // if (e.type === this.TYPE_MILE) {
        //   response = await jobServices.deleteJobRouteMileImages(e.images);
        // } else if (e.type === this.TYPE_INVOICE) {
        //   response = await jobServices.deleteJobRouteInvoiceImages(e.images);
        // } else if (e.type === this.TYPE_PRODUCT) {
        //   response = await jobServices.deleteJobRouteProductImages(e.images);
        // }
        modalSuccess(this.$bvModal, "ลบรูปเสร็จสิ้น");
        await this.getJob();
      } catch (error) {
        console.error("Error deleting images:", error);
      }
    },
    async submitRouteWarehouse() {
      try {
        this.isLoadPage = true;
        const response = await jobServices.sendJobWarehouse({
          job_id: this.jobId,
          distance_to_warehouse: this.job.distance_to_warehouse,
        });

        if (response.status === 200 && response.data && response.data.data) {
          modalSuccess(this.$bvModal, "ส่งงานกลับคลังสินค้าสำเร็จ");
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        const message =
          error.response &&
          error.response.data &&
          error.response.data.data === "job not found"
            ? "ไม่พบงานที่ต้องการส่ง"
            : "เกิดข้อผิดพลาดในการส่งงาน";

        modalError(this.$bvModal, message);
      } finally {
        this.isLoadPage = false;
      }
    },
    async submitRoute(routeId) {
      try {
        this.isLoadPage = true;
        const response = await jobServices.sendJobRoutes(routeId);

        if (response.status === 200 && response.data && response.data.data) {
          modalSuccess(this.$bvModal, "ส่งงานสำเร็จ");
          // ทำการอัปเดตข้อมูลหรือรีเฟรชข้อมูลถ้าจำเป็น
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error submitting route:", error);
        const message =
          error.response &&
          error.response.data &&
          error.response.data.data === "job not found"
            ? "ไม่พบงานที่ต้องการส่ง"
            : "เกิดข้อผิดพลาดในการส่งงาน";
        modalError(this.$bvModal, message);
      } finally {
        this.isLoadPage = false;
      }
    },
    async deleteRoute(route) {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "คุณแน่ใจว่าต้องการลบเส้นทางนี้หรือไม่?",
        {
          title: "ยืนยันการลบ",
          okTitle: "ใช่",
          cancelTitle: "ไม่ใช่",
          centered: true,
        }
      );

      if (!confirmed) {
        return;
      }

      if (route.id) {
        try {
          this.isLoadPage = true;
          const response = await jobServices.deleteJobRoute({
            job_id: this.jobId,
            route_id: String(route.id),
          });
          if (response.status === 200 && response.data) {
            modalSuccess(this.$bvModal, "ลบเส้นทางสำเร็จ");
            await this.getJob();
          } else {
            throw new Error("Unexpected response format");
          }
        } catch (error) {
          console.error("Error deleting route:", error);
          modalError(this.$bvModal, "เกิดข้อผิดพลาดในการลบเส้นทาง");
        } finally {
          this.isLoadPage = false;
        }
      } else {
        this.job.jobRoutes = this.job.jobRoutes.filter((r) => r !== route);
      }
    },
    async confirmCloseJob() {
      const confirmed = await this.$bvModal.msgBoxConfirm(
        "คุณแน่ใจว่าต้องการปิดงานนี้หรือไม่?",
        {
          title: "ยืนยันการปิดงาน",
          okTitle: "ใช่",
          cancelTitle: "ไม่ใช่",
          centered: true,
        }
      );

      if (!confirmed) {
        return;
      }

      await this.closeJob();
    },

    async closeJob() {
      try {
        this.isLoadPage = true;
        const response = await jobServices.confirmDriverJob({
          job_id: this.jobId,
          status: STATUS_SUCCESS,
        });
        if (response.status === 200 && response.data) {
          modalSuccess(this.$bvModal, "ปิดงานสำเร็จ").then(() => {
            this.$router.push({
              name: "home",
            });
          });
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        if (error.response.data.message === "job route not complete") {
          modalError(
            this.$bvModal,
            "ไม่สามารถปิดงานได้ เนื่องจากยังส่งงานไม่สำเร็จ"
          );
        }

        if (error.response.data.message === "Job route not success") {
          modalError(
            this.$bvModal,
            "ไม่สามารถปิดงานได้ เนื่องจากยังส่งงานไม่สำเร็จ"
          );
        }
      } finally {
        this.isLoadPage = false;
      }
    },
    checkIsSuccess(status) {
      return status === STATUS_SUCCESS ? true : false;
    },
  },
  async mounted() {
    this.checkParam();
    await this.getJob();
  },
};
</script>
